"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analytics = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function exportParams(channel, dates, video) {
    var params = __assign({ viewed: true, sort: 'date asc', channel_id: channel.id }, dates);
    if (video.id) {
        params.video_id = video.id;
    }
    return params;
}
var Analytics = function (_a) {
    var channel = _a.channel;
    var _b = react_1.useState({}), dates = _b[0], setDates = _b[1];
    var _c = react_1.useState({ id: null }), video = _c[0], setVideo = _c[1];
    var metrics = storybook_1.Hooks.useAnalytics({
        channel_id: channel.id,
        type: 'metrics',
        days: 7,
        viewed: true
    }, dates, video);
    react_1.useEffect(function () {
        if (metrics.meta && metrics.meta.search) {
            setDates(metrics.meta.search);
        }
    }, [metrics.meta]);
    return react_1.default.createElement(storybook_1.Layouts.Container, null,
        react_1.default.createElement(storybook_1.Analytics.Export, { params: exportParams(channel, dates, video) }),
        metrics.meta && metrics.meta.search && react_1.default.createElement(storybook_1.Analytics.FormDates, { clearable: metrics.meta.search.from !== metrics.meta.sevendays.from || metrics.meta.search.till !== metrics.meta.sevendays.till, dates: dates, setDates: setDates, clearDates: function () { return setDates(metrics.meta.sevendays); } }),
        react_1.default.createElement(storybook_1.Analytics.VideoFilter, { video: video, setVideo: setVideo, channelId: channel.id }),
        metrics.loading &&
            react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'loader' })),
        !metrics.loading && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(storybook_1.Analytics.Metrics, { metrics: metrics.data.first() }),
            react_1.default.createElement(storybook_1.Analytics.Graph, { loading: metrics.loading, channel: channel, dates: dates, params: __assign(__assign({ channel_id: channel.id, days: 7, type: 'date', viewed: true }, dates), { video_id: video.id }) })));
};
exports.Analytics = Analytics;
exports.Analytics.propTypes = {
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
    }),
};
